/* et-time.js — single source of truth for Miami (America/New_York) date parts.
   Used by the closed-Sunday messaging in theme.liquid and the limited-stock badge. */
window.fitbellyETParts = function () {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    weekday: 'short',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit',
    hourCycle: 'h23', // clean 00–23 (avoids the "24" midnight quirk)
  }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t).value;
  const DAY_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  return {
    day: DAY_INDEX[get('weekday')],
    hour: parseInt(get('hour'), 10),
    dateKey: `${get('year')}-${get('month')}-${get('day')}`,
  };
};
